module.exports = __webpack_public_path__ + "static/img/wh_case.ffdb5d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wh_case.jpg
// module id = b5i4
// module chunks = 1